import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import {
  NdcPreferenceCreatePayload,
  createNdcPreference,
  getNdcPreferences,
  getNdcSupportedCarriers,
  updateNdcPreference,
} from '~/services/BusinessTraveller/BusinessTravellerService';

export const ndcPreferenceQueryKeys = {
  all: ['businessNdcPreferences'],
  list: (businessId: string) => [...ndcPreferenceQueryKeys.all, 'list', businessId],
  supportedCarriers: () => [...ndcPreferenceQueryKeys.all, 'supportedCarriers'],
};

export function useGetNdcSupportedCarriers() {
  return useQuery({
    queryKey: ndcPreferenceQueryKeys.supportedCarriers(),
    queryFn: () => getNdcSupportedCarriers(),
  });
}

export function useGetBusinessNdcPreferences(businessId: string) {
  return useQuery({
    queryKey: ndcPreferenceQueryKeys.list(businessId),
    queryFn: () => getNdcPreferences(businessId),
    enabled: !!businessId,
  });
}

export function useCreateBusinessNdcPreference(businessId: string) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (payload: NdcPreferenceCreatePayload) => createNdcPreference(businessId, payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ndcPreferenceQueryKeys.list(businessId) });
    },
  });
}

export function useUpdateBusinessNdcPreference(businessId: string) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ ndcPreferenceId, enabled }: { ndcPreferenceId: string; enabled: boolean }) =>
      updateNdcPreference(businessId, ndcPreferenceId, { enabled }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ndcPreferenceQueryKeys.list(businessId) });
    },
  });
}
